import moment from "moment";
import React, { useState } from "react";

const formatData = (date) => {
  return moment(date).format("DD/MM/yyyy");
};

export default formatData;
